import { useEffect } from "react";
import { usePresentationMode } from "@/contexts/PresentationModeContext";
import { toast } from "sonner";

// Small controller to add a global keyboard shortcut (Alt+P) to toggle Presentation Mode
// and display a toast notification so presenters get feedback.
export const PresentationModeController = () => {
  const { enabled, toggle } = usePresentationMode();

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Alt + P to toggle
      if (e.altKey && (e.key === "p" || e.key === "P")) {
        e.preventDefault();
        toggle();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [toggle]);

  useEffect(() => {
    // Inform user when mode changes
    toast(enabled ? "Presentation Mode enabled (animations paused)" : "Presentation Mode disabled");
  }, [enabled]);

  return null;
};

export default PresentationModeController;
